<template>
  <div class="login form">


    <div class="step">
      <form action="" @submit.prevent="mail_recovery_send">
        <h4 class="anim center">Mot de passe oublié</h4>
        
        <label class="anim">Adresse E-mail</label>
        <el-input class="anim" type="email" v-model="email" name="email"></el-input>
        
        <button class="anim">Envoyer</button>

      </form>
    </div>

  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data() {
    return {
      email: null,
    }
  },
  name: "join",
  mounted() {
    this.step_anim()

  },
  watch: {
    step() {
      this.step_anim()
    }
  },
  methods: {
    mail_recovery_send() {
      if (!this.email) return

      this.$http.post('/user/mail_recovery_send', {email: this.email}).then((r) => {
        console.log(r)
        if (r.status === 200) {
          this.$notify({
            title: 'Mail de récup envoyé', offset: this.$notifyOffest, type: 'success',
          });
          this.$router.push({ name: 'Home' })
        }
      }).catch((e) => {
        this.$notify({
          title: e.response.data, offset: this.$notifyOffest, type: 'error',
        });
      })
    },
    step_anim() {
      anime({ targets: '.anim', opacity: 0, duration: 0 })
      setTimeout(function() {
        anime({
          targets: '.step .anim',
          translateX: ['-30px', 0],
          opacity: [0, 1],
          easing: 'easeOutCubic',
          duration: 400,
          delay: anime.stagger(20)
        })
      }, 0)
    }
  }
}
</script>

<style scoped>

.login { background-color: #ee5522;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23FB3'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23f7882b'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg %3E%3Cg transform=''%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform=''%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.24' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover; }

.login .step { background: #fff; padding: 10px 32px 32px; }




/*.digits { margin-top: 30px; }*/
.anim { opacity: 0 }
.step .info { margin-bottom: 30px; font-size: 12px; margin-top: 14px; letter-spacing: 1.1px; line-height: 24px }

form { display: flex; flex-direction: column }

.button.fb {
  background: #1877f2;
  display: flex;
  justify-content: center; align-items: center;
  text-transform: none;
  font-size: 18px;
  font-weight: 500;
}

.button.fb img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
}

.step { display: flex; flex-direction: column }

.step.fb { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: calc((var(--vh, 1vh) * 100) - 60px); }
.step.fb img { width: 100%; height: 100%; background: #ccc; border-radius: 100%; border: none; position: relative; z-index: 2; }

.step.fb .img { position: relative;  width: 50vw; height: 50vw;  margin-bottom: 16px;}

.pasencoreinscrit { display: flex; align-items: center; flex-direction: column; font-size: 18px; padding-top: 20px; margin-top: 20px; border-top: 1px solid #eee; }
.pasencoreinscrit span { font-weight: bold; }
.pasencoreinscrit a { font-size: 16px; margin-top: 10px; }

.load {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vw;
}
.load i {
  background: #af36e5;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  border-radius: 100%;
  animation: circle 1.2s linear infinite 0s;
}
.load i:nth-child(2) {
  animation-delay: 0.5s;
}
.load i:nth-child(3) {
  animation-delay: 1s;
}
button { margin-top: 30px; }

.title { padding-bottom: 20px; }

@keyframes circle {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  10% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}

@media only screen and (min-width: 800px) {
  /*.login .step {  padding: 32px var(--padding) }*/
  

  .login { display: flex; align-items: center; justify-content: center; padding-bottom: 140px; min-height: calc((var(--vh, 1vh) * 100) - 70px); }
  .login .step { min-width: 400px; }
  .login form { max-width: 340px; }
}

</style>